import React, {Component} from 'react';
import {HashRouter as Router, Route, Redirect, Switch} from 'react-router-dom';
import {AUTH_TOKEN_STORAGE_KEY, COMPANY_ID_STORAGE_KEY} from '../../constants/storageConstants';
import {ROLE_REPORT_USER} from '../../constants/roles';
import LoginPage from '../login/LoginPage';
import HomePage from '../home/HomePage';
import defaultPath from '../../config/defaultPath';
import GuestPage from '../guest/GuestPage';

const JWT_PREFIX = 'JWT ';

export const getUser = () => {
  let token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  if (token) return token.replace(JWT_PREFIX, '');
  return undefined;
};

export const getCompany = () => {
  let companyId = localStorage.getItem(COMPANY_ID_STORAGE_KEY);
  if (companyId) return companyId;
  return undefined;
};

export default class AppNavigation extends Component {
  state = {};

  render() {
    let user = getUser();
    let company = getCompany();
    return (
      <Router>
        <Switch>
          <Route
            exact
            path="/login"
            render={props =>
              getUser() ? (
                <Redirect to={{pathname: defaultPath, state: {from: props.location}}} />
              ) : (
                <LoginPage {...props} rerender={() => this.setState({update: Date.now()})} />
              )
            }
          />
          <Route
            exact
            user={user}
            role={ROLE_REPORT_USER}
            path="/guest"
            render={props => <GuestPage user={user} {...props} />}
          />
          <Route
            user={user}
            role={ROLE_REPORT_USER}
            path="/"
            render={props => <HomePage user={user} company={company} {...props} />}
          />
        </Switch>
      </Router>
    );
  }
}
